export const skeletonWidthCols = {
  first: { desktop: 25, tablet: 25 },
  second: { desktop: 25, tablet: 25 },
  third: { desktop: 25, tablet: 25 },
  fourth: { desktop: 25, tablet: 25 },
};
